export const OTP_CODE_LENGTH = 6;

export const OTP_CANONICAL_ALPHABET = 'ACEFHJKMNPRTVWXY0123456789';

export const OTP_NORMALIZATION_MAP: Record<string, string> = {
  B: '8',
  D: '0',
  G: '6',
  I: '1',
  L: '1',
  O: '0',
  Q: '9',
  S: '5',
  U: 'V',
  Z: '2',
};
